import { z } from 'zod';
import {
  uuidSchema,
} from './primitives.js';

/** Provider site-scoped query: tenantId from query string. */
export const LocationProviderTenantQuerySchema = z.object({
  tenantId: uuidSchema,
});


/** Wizard run query for vendor import. */
export const LocationIntegrationWizardRunQuerySchema = z.object({
  tenantId: uuidSchema,
  registerTags: z.string().optional(),
});


/** Empty JSON object body (e.g. gateway assign PUT). */
export const EmptyJsonBodySchema = z.object({}).strict();

/** Provider tenant gateway overrides query (location only in this migration batch). */
export const GatewayTypeLocationQuerySchema = z.object({
  gatewayType: z.literal('location'),
});
// Inferred types
export type EmptyJsonBody = z.infer<typeof EmptyJsonBodySchema>;
export type GatewayTypeLocationQuery = z.infer<typeof GatewayTypeLocationQuerySchema>;
export type LocationIntegrationWizardRunQuery = z.infer<typeof LocationIntegrationWizardRunQuerySchema>;
export type LocationProviderTenantQuery = z.infer<typeof LocationProviderTenantQuerySchema>;
